module.exports = __webpack_public_path__ + "img/28.ba14098e.jpg";